<div class="grid mt-0">
	<!-- NO SITE SELECTED ALERT -->
	<div *ngIf="currentSite === undefined" class="col-12">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<i class="pi cm-alert text-lg text-yellow-700"></i>
			<p-tag *ngIf="originComponent === 'devices-list'" [value]="('NO_SITE_DEVICE_ALERT' | translate)" severity="warning"></p-tag>
			<p-tag *ngIf="originComponent === 'scenarios'" [value]="('NO_SITE_SCENARY_ALERT' | translate)" severity="warning"></p-tag>
			<p-tag *ngIf="originComponent === 'permissions'" [value]="('NO_SITE_PERMISSIONS_ALERT' | translate)" severity="warning"></p-tag>
		</div>
	</div>
	<!-- SHARED SITE ALERT -->
	<div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="('SHARED_SITE' | translate)" styleClass="p-tag-purple"></p-tag>
		</div>
	</div>
	<!-- TIMEZONE SITE NOT SET -->
	<div *ngIf="timezoneNotSet() && currentSite?.CurrentlyOwned" class="col-12">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag *ngIf="originComponent === 'devices-list'" icon="pi cm-alert" [value]="('TIMEZONE_NOT_SET_WARNING' | translate)" severity="warning"></p-tag>
			<p-tag *ngIf="originComponent === 'scenarios'" icon="pi cm-alert" [value]="('TIMEZONE_NOT_SET_WARNING_FEATURE_LIMITATIONS' | translate)" severity="warning"></p-tag>
			<p-tag *ngIf="originComponent === 'permissions'" icon="pi cm-alert" [value]="('TIMEZONE_NOT_SET_WARNING_FEATURE_LIMITATIONS' | translate)" severity="warning"></p-tag>
		</div>
	</div>
</div>